import * as React from 'react';

import { QuizQuestionOrderUrl } from '../../../../api/question/questionApi';

const QuizQuestionOrderUrlContext =
  React.createContext<QuizQuestionOrderUrl>(undefined);

interface Props {
  quizQuestionOrderUrl: QuizQuestionOrderUrl;
  children: React.ReactNode;
}

export function QuizQuestionOrderUrlProvider({
  quizQuestionOrderUrl,
  children,
}: Props) {
  return (
    <QuizQuestionOrderUrlContext.Provider value={quizQuestionOrderUrl}>
      {children}
    </QuizQuestionOrderUrlContext.Provider>
  );
}

export function useQuizQuestionOrderUrl() {
  const value = React.useContext(QuizQuestionOrderUrlContext);
  if (value === undefined) {
    throw new Error(
      'Quiz Question Order Url Value is not defined. Ensure this component is wrapped inside a QuizQuestionOrderUrlProvider component'
    );
  }
  return value;
}
